module.exports = __webpack_public_path__ + "media/images/flower4-9bf00423f6315c4a42c09945d1f169c6.png";